export default {
  initRem: function () {
    var docEl = document.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function () {
        var clientWidth = docEl.clientWidth
        if (!clientWidth) return
        let heash = location.hash.split('=')[0].replace('#/', '').replace('?ids', '')
        // console.log(heash)
        if (heash === 'result' || heash === 'examination') {
          // console.log('pc')
          docEl.style.fontSize = 100 * (clientWidth / 1280) + 'px'
        } else {
          // console.log('移动')
          docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
        }
        /* docEl.style.fontSize = 20 * (clientWidth / 320) + 'px'; */
      }
    if (!document.addEventListener) return
    window.addEventListener(resizeEvt, recalc, false)
    document.addEventListener('DOMContentLoaded', recalc, false)
  },
  updateRem: function () {
    var docEl = document.documentElement
    var clientWidth = docEl.clientWidth
    if (!clientWidth) return
    let heash = location.hash.split('=')[0].replace('#/', '').replace('?ids', '')
    // console.log(heash)
    if (heash === 'result' || heash === 'examination' || heash === 'signIn' || heash === 'exam' || heash === 'examinationEnd' || heash === 'somatosensorys') {
      // console.log('pc')
      docEl.style.fontSize = 100 * (clientWidth / 1280) + 'px'
    } else {
      // console.log('移动')
      docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/rem2.js